import React, { Component } from "react";
import { connect } from "react-redux";
import instance from "../../../store/actions/instance";

import { TextField, Button } from "@material-ui/core";
import ProductHeader from "../../ProductDetails/ProductHeader";
import CircularProgress from "@material-ui/core/CircularProgress";
import ActionButton from "../../ActionButton";
import Stepper from "./Stepper";
import { ReactComponent as Error } from "./close.svg";
import { ReactComponent as Tick } from "./tick.svg";
import { GetApp } from "@material-ui/icons";
import { Redirect } from "react-router/cjs/react-router.min";
export class index extends Component {
  state = {
    tracking_id: this.props.match.params.tracking_id
      ? this.props.match.params.tracking_id
      : this.props.history.location.state
      ? this.props.history.location.state.trackingCode
      : "",
    order: undefined,
    loading: false,
    activeStep: -1,
    isCancelled: false
  };
  componentDidMount = () => {
    window.scrollTo(0, 0);
    if (this.state.tracking_id) {
      this.handleCheck();
    }
  };

  async handleCheck() {
    let res = null;
    if (!this.state.tracking_id) return;
    this.setState({ loading: true });
    if (this.state.tracking_id) {
      res = await instance.get(
        `/track_order/${this.state.tracking_id.trim()}/`
      );

      this.setState({ order: res.data, loading: false });
      if (res.data != "Error") {
        if (res.data.status == "Cancelled")
          this.setState({ isCancelled: true, activeStep: 1 });
        else if (res.data.status == "New") this.setState({ activeStep: 1 });
        else if (res.data.status == "Received")
          this.setState({ activeStep: 2 });
        else if (res.data.status == "Preparing")
          this.setState({ activeStep: 3 });
        else if (res.data.status == "Out for Delivery")
          this.setState({ activeStep: 4 });
        else if (res.data.status == "Complete")
          this.setState({ activeStep: res.data.is_pick_up ? 4 : 5 });
      } else {
        this.setState({ activeStep: -1 });
      }
    }
  }

  render() {
    const language = this.props.language;
    if (!this.props.settings.enable_tracking) return <Redirect to="/" />;
    return (
      <div style={{ backgroundColor: "white", minHeight: window.outerHeight }}>
        <ProductHeader
          title={language == "english" ? "Order Tracking" : "تتبع الطلب"}
          onBack={() => this.props.history.goBack()}
        />
        <div className="free-space-70-white"></div>
        <p
          className={"w-100 ".concat(
            language == "english" ? "text-left pl-3" : "text-right pr-3"
          )}
          style={{ fontSize: "1.2rem" }}
        >
          {language == "english" ? "Track your order" : "تتبع طلبك"}
        </p>

        <div
          className="row mb-4 mx-auto"
          style={{
            marginTop: 30,
            width: "92%"
          }}
          dir={language == "english" ? "ltr" : "rtl"}
        >
          <div className="col-11 align-self-center pr-0 pl-0 ">
            <TextField
              id="standard-basic"
              label={language == "english" ? "Tracking ID" : "رقم التتبع"}
              fullWidth
              InputLabelProps={{
                style: {
                  right: language == "arabic" && 5,
                  left: language == "arabic" && "auto"
                },
                dir: language == "english" ? "ltr" : "rtl"
              }}
              InputProps={{
                dir: language == "english" ? "ltr" : "rtl"
              }}
              color="primary"
              className=""
              onChange={e =>
                this.setState({
                  tracking_id: e.target.value,
                  order: this.state.order == "Error" ? null : this.state.order
                })
              }
              name="tracking_id"
              value={this.state.tracking_id}
              FormHelperTextProps={{
                style: {
                  textAlign: language == "arabic" && "right",
                  marginRight: language == "arabic" && 5
                }
              }}
            />
          </div>
          <div
            className={"col-1 align-self-center p-0 ".concat(
              language == "english" ? "text-right" : "text-left"
            )}
          >
            {this.state.loading ? (
              <CircularProgress size={25} />
            ) : (
              this.state.order &&
              (this.state.order == "Error" ? (
                <Error width={20} height={20} />
              ) : (
                <Tick width={20} height={20} />
              ))
            )}
          </div>
        </div>

        <Stepper
          activeStep={this.state.activeStep - 1}
          language={language}
          isPickup={this.state.order ? this.state.order.is_pick_up : null}
          isCancelled={this.state.isCancelled}
        />
        <ActionButton
          action={language == "english" ? "Check Status" : "التحقق من الطلب"}
          onClick={() => this.handleCheck()}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    language: state.store.language,
    settings: state.store.store.settings
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(index);
